import axios from "axios";
import { Message } from "element-ui";
import router from "../router/index";
// 创建axios实例
const service = axios.create({
  baseURL: "https://vectory.xinzhiyukeji.cn/", // api的base_url
  timeout: 50000, // 请求超时时间
});

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// const getToken = Cookies.get(TokenKey)
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // if (config.headers["Content-Type"] == "multipart/form-data") {
    //   config.headers["Content-Type"] = "multipart/form-data";
    // }
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    if (!isToken) {
      let token = localStorage.getItem("token");
      config.headers["ba-user-token"] = token; // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["server"] = "1"; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 可以在这里添加请求头等信息
    return config;
  },
  (error) => {
    // 请求错误处理
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 未设置状态码则默认成功状态
    const code = response.data.code || 200;
    // 获取错误信息
    const msg = response.data.msg;
    // 对响应数据做处理，例如只返回data部分
    const res = response.data;
    // 根据返回的状态码做相应处理，例如401未授权等
    // if (code === 303) {
    // //   router.push({ path: "/" });
    // //   localStorage.clear();
    // //   return;
    //   Message({ message: msg, type: 'error' })
    //   return Promise.reject(new Error(msg))
    // } else {
    // }
    return res;
  },
  (error) => {
    // 响应错误处理
    console.log("err" + error); // for debug
    // return Promise.reject(error);
  }
);

export default service;
